export interface IFirebaseError {
  code: string;
  message: string;
}
